<template>
    <footer class="footer">
        <div class="container">
            <p class="pull-left text-secondary">
                <img class="mright10" :src="`${$root.publicURL}images/footer-logo.png`" :alt="`© Opencode Systems ${getDate.getFullYear()}`">
            </p>
            <p class="pull-right portal-version">Version: {{version}}</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    computed: {
        getDate() {
            return new Date()
        },
        version() {
            return _appConfig.version
        }
    }
}
</script>

<style scoped>
    html {
        position: relative;
        /* min-height: 100%; */
    }
    body {
        /* Margin bottom by footer height */
        margin-bottom: 61px;
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-bottom: 0px;
        /* Set the fixed height of the footer here */
        height: 60px;
        line-height: 58px; /* Vertically center the text there */

        background-color: #f1f1f1;
        border-top: 1px solid #ddd;
        color: #888;
    }

    .footer p {
        margin: 0;
    }

    .footer p.portal-version {
        color: #888;
    }
</style>
